import { Link } from "react-router-dom";
import { blogs } from "../../data/blogs";

const Blogs = () => {
    const getImage = (filename: string) => {
        return require(`../../assets/images/${filename}`);
    };
  return (
    <div className="container py-5">
      <h1 className="mb-4">Blogs</h1>
      <div className="row">
        {blogs.map((blog) => (
          <div className="col-md-6 mb-4" key={blog.id}>
            <div className="card h-100">
              <img src={getImage(blog.coverImage)} className="card-img-top" alt={blog.title} />
              <div className="card-body d-flex flex-column">
                <h5 className="card-title">{blog.title}</h5>
                <p className="card-text">{blog.excerpt}</p>
                <Link to={`/blogs/${blog.slug}`} className="btn btn-primary mt-auto">
                  Read More
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Blogs;
